// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5954a915","632":"54359c14","820":"3c353164"}[chunkId] + ".chunk.js";
};